export const en = {
    'column-title-city': 'City',
    'column-title-feedbacks': 'Reviews',
    'column-title-freelancers': 'Experts',
    'column-title-score': 'Ratings',
    'column-title-services': 'Cost and duration',
    noScore: 'Few reviews'
};
